module.exports = __webpack_public_path__ + "img/f2.cc76ecff.png";